import { cva } from "class-variance-authority"
import { Z_INDEX_CLASSES } from "../../../lib/z-index"

/**
 * Sticky column styles for the action column pinned to the right edge.
 * 
 * IMPORTANT: We use explicit opaque backgrounds for each row state instead of
 * `bg-inherit`, because `bg-inherit` resolves to the parent <tr>'s computed
 * background which can be transparent in certain states, causing the scrolling
 * content underneath to bleed through the sticky cell.
 */

const STICKY_HEADER_BASE = `sticky ${Z_INDEX_CLASSES.STICKY_HEADER} bg-component right-0 text-center w-12 min-w-12 max-w-12 px-1 transition-colors duration-200`

const STICKY_ROW_BASE = [
  "sticky right-0 text-center w-12 min-w-12 max-w-12 px-1 transition-colors duration-200",
  Z_INDEX_CLASSES.TABLE_STICKY,
  // Explicit opaque backgrounds per row state to prevent content bleed-through
  "bg-card",
  "group-hover:bg-gray-50 dark:group-hover:bg-gray-800/50",
  "group-data-[state=selected]:bg-gray-100 dark:group-data-[state=selected]:bg-gray-800",
  "group-data-[active=true]:bg-primary-light dark:group-data-[active=true]:bg-primary-light",
].join(" ")

const STICKY_LOADING_BASE = `sticky ${Z_INDEX_CLASSES.TABLE_STICKY} bg-component right-0 text-center w-12 min-w-12 max-w-12 px-1 transition-colors duration-200`

const SHADOW_CLASS = "drop-shadow-[-4px_0_8px_rgba(11,59,69,0.08)] dark:drop-shadow-[-4px_0_8px_rgba(0,0,0,0.2)]"

const shadowVariants = {
  variants: {
    showRightShadow: {
      true: SHADOW_CLASS,
      false: ""
    }
  },
  defaultVariants: {
    showRightShadow: false
  }
}

export const stickyHeaderVariants = cva(STICKY_HEADER_BASE, shadowVariants)
export const stickyRowCellVariants = cva(STICKY_ROW_BASE, shadowVariants)
export const stickyLoadingCellVariants = cva(STICKY_LOADING_BASE, shadowVariants)
